import { CostMethodSelector } from "./CostMethodSelector"
import { DocumentTypeSelect } from "./DocumentTypeSelect"
import { InventoryLocationSelect } from "./InventoryLocationSelect"
import { MainTabs } from "./MainTabs"
import { StockLocationTabs } from "./StockLocationTabs"
export * from "./StockDirectionPlaceholder"
export * from "./StockDocumentFooter"
export const MainTabsComponent = MainTabs
export const CostMethodSelectorComponent = CostMethodSelector
export const DocumentTypeSelectComponent = DocumentTypeSelect
export const InventoryLocationSelectComponent = InventoryLocationSelect
export const StockLocationTab = StockLocationTabs



// WEBPACK FOOTER //
// ./src/inventory/components/index.ts